// services/employeeApi.js

export const employeeEndpoints = (builder) => ({

    saveEmployee: builder.mutation({
        query: (data) => ({
            url: "/admin/employee",
            method: "POST",
            body: data
        }),
        invalidatesTags: ["Employee"],
    }),

    updateEmployee: builder.mutation({
        query: ({ id, data }) => ({
            url: `/admin/update_employee/${id}`,
            method: "PUT",
            body: data
        }),
    }),

    getEmployeeList: builder.query({
        query: (data) => ({
            url: "/admin/employee-list",
            method: "POST",
            body: data
        }),
        providesTags: ["Employee"],
    }),

    getEmployeeById: builder.query({
        query: (id) => `/admin/employeebyid/${id}`,
    }),

    deleteEmployee: builder.mutation({
        query: (data) => ({
            url: "/admin/delete-employee",
            method: "POST",
            body: data
        }),
    }),

});